/**
 * Parse JSON from localStorage/sessionStorage with a size limit to avoid V8 OOM
 * when restoring corrupted or unexpectedly large persisted values.
 * Limits are high (64MB) to allow large valid caches; they guard against corruption only.
 */
const DEFAULT_MAX_BYTES = 64 * 1024 * 1024 // 64MB

export function safeParseJson<T>(
  raw: string | null,
  maxBytes: number = DEFAULT_MAX_BYTES
): T | null {
  if (raw == null || raw === '') return null
  if (raw.length > maxBytes) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[safeStorageParse] Skipping parse: value exceeds limit', {
        length: raw.length,
        maxBytes,
      })
    }
    return null
  }
  try {
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}
